define('ET/ETCollection',[
    "evertrue",
    "jquery",
    "underscore",
    "backbone",
    'ET/ETModel'
], function ETCollectionFactory ( EverTrue, $, _, Backbone, ETModel) {
    // Extend the bacbone Model with our EverTrue model w/ default functionality
    var ETCollection = Backbone.Collection.extend({
        model: ETModel,
        url : window.url,
        parse: EverTrue.Parser,
        sync : EverTrue.sync,
        initialize : function(){
            if (this.useLocalStorage !== false) {
                this.on('sync', this.saveToStorage,this);
            }
        },
        saveToStorage : function(){
            if (_.isFunction(this.urlRoot)){
                this.urlRoot = this.urlRoot();
            }
            var key = this.urlRoot + '_collection';
            EverTrue.amplify(key, this.toJSON());
        }
    });
    ETCollection.include = EverTrue.include;
    return ETCollection;
});

